export enum BreakpointValues {
  large = "lg",
  tabletLandscape = "tablet-landscape",
  tabletPortrait = "tablet-portrait",
  small = "sm",
}
